import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from '@atlassian/jira-relay/src/__generated__/AccountMenuContentContainerQuery$parameters';

export const Nav4ProfileMenuEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "atlassian-navigation-profile-menu" */ './src/ui/profile-menu/AccountMenuContentContainer.tsx'
			),
	),
	getPreloadProps: ({
		atlassianAccountId,
		jiraOnboardingHubGateEnabled,
	}: {
		atlassianAccountId?: string;
		jiraOnboardingHubGateEnabled?: boolean;
	}) => ({
		queries: {
			AccountMenuContentContainerQuery: {
				parameters,
				variables: {
					atlassianAccountId: atlassianAccountId ?? '',
					jiraOnboardingHubGateEnabled: jiraOnboardingHubGateEnabled ?? false,
				},
			},
		},
	}),
});
